/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module ApplicationInsightsPolicyModule
 */

import { ApplicationInsightsPolicy } from 'object-types';
import { AviPermissionResource } from 'generated-types';
import { Collection } from 'ajs/modules/data-model/factories/collection.factory';

import { APPLICATION_INSIGHTS_POLICY_ITEM_TOKEN } from '../application-insights-policy.tokens';

/**
 * @description
 *     Application Insights Policy Collection class.
 * @author Zhiqian Liu
 */
export class ApplicationInsightsPolicyCollection extends Collection {
    public static ajsDependencies = [
        APPLICATION_INSIGHTS_POLICY_ITEM_TOKEN,
    ];

    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'applicationinsightspolicy',
            windowElement: 'lazy-load',
            objectType: ApplicationInsightsPolicy,
            permissionName: AviPermissionResource.PERMISSION_APPLICATIONINSIGHTSPOLICY,
            ...args,
        };

        super(extendedArgs);
        this.itemClass_ = this.getAjsDependency_(APPLICATION_INSIGHTS_POLICY_ITEM_TOKEN);
    }
}

/**
 * Type for ApplicationInsightsPolicyCollection collection.
 */
export type TApplicationInsightsPolicyCollection = typeof ApplicationInsightsPolicyCollection;
